import { useDebouncedState } from '@react-hookz/web';
import { useEffect } from 'react';

import { DEFAULT_ANNOUNCEMENT_DELAY } from './LiveRegionAnnouncer.constants';
import type { LiveRegionAnnouncerProps } from './LiveRegionAnnouncer.types';
import { useLiveRegion } from './useLiveRegion';
import type { Announcement } from './useLiveRegion.types';
import { DEFAULT_ANNOUNCEMENT_PRIORITY } from './useLiveRegions.constants';

export function LiveRegionAnnouncer({
  debounceDelay = DEFAULT_ANNOUNCEMENT_DELAY,
  priority = DEFAULT_ANNOUNCEMENT_PRIORITY,
  message,
}: LiveRegionAnnouncerProps) {
  const [announcement, setAnnouncement] =
    useDebouncedState<Announcement | null>(null, debounceDelay);
  const { announce } = useLiveRegion();

  useEffect(() => {
    if (announcement) {
      announce(announcement?.message, announcement?.priority);
    }
  }, [announce, announcement]);

  useEffect(() => {
    if (!message) {
      setAnnouncement(null);
      return;
    }

    setAnnouncement({ message, priority });
  }, [message, priority, setAnnouncement]);

  return null;
}
